export const PROFILE_INPUT_WIDTH = 355;
